import { render, staticRenderFns } from "./AddModuleToDevice.vue?vue&type=template&id=19de345a&scoped=true&"
import script from "./AddModuleToDevice.vue?vue&type=script&lang=ts&"
export * from "./AddModuleToDevice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de345a",
  null
  
)

export default component.exports